<!--
  Обёртка над InventTypeFieldSetting для собственных полей конструктора паспорта:
  проецирует draft (numeric field_type + validation_props) в legacy ObjectInventoryField,
  а на закрытии сливает скаляры ограничений обратно в validation_props.
-->
<script setup lang="ts">
import { ref, watch } from 'vue'
import { InventTypeFieldSetting } from '@/entities/Inventory/TypeField'
import type { ObjectInventoryField } from '@/entities/Inventory/ObjectTypes'
import {
  draftToLegacySettingsField,
  mergeSettingsIntoDraftValidationProps,
  type PassportBuilderFieldTypeDto,
  type PassportBuilderObjectTypeFieldDraft,
} from '../model/objectTypeFields'

const open = defineModel<boolean>({ required: true })

const props = withDefaults(
  defineProps<{
    draft: PassportBuilderObjectTypeFieldDraft | null
    fieldTypes?: PassportBuilderFieldTypeDto[]
  }>(),
  { fieldTypes: () => [] },
)

const projected = ref<ObjectInventoryField | null>(null)

/** На открытии — свежая проекция из draft; на закрытии — слив настроек обратно. */
watch(
  () => [open.value, props.draft] as const,
  ([isOpen, draft]) => {
    if (isOpen && draft) {
      projected.value = draftToLegacySettingsField(draft, props.fieldTypes)
      return
    }
    if (!isOpen && projected.value && draft) {
      mergeSettingsIntoDraftValidationProps(draft, projected.value)
    }
  },
  { immediate: true },
)
</script>

<template>
  <InventTypeFieldSetting
    v-if="projected"
    v-model="open"
    v-model:field="projected"
    :hide-mandatory="true"
  />
</template>
